import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const TermsAndConditions = () => {
  return (
    <>
      <Header />
      <div className="min-h-screen bg-black text-white">
        {/* Hero Section */}
        <div className="relative pt-32 pb-20 px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-AfacadFluxLight font-bold text-white mb-8">
              Terms & Conditions
            </h1>
            <p className="text-xl text-gray-300 leading-relaxed">
              Welcome to Venturecorp. By using this website, you agree to the following:
            </p>
          </div>
        </div>

        {/* Content Section */}
        <div className="pt-4 pb-16 px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <div className="space-y-12">
              {/* Section 1: Use of Website */}
              <div className="bg-slate-900/50 rounded-lg p-8 border border-gray-800/50">
                <h2 className="text-2xl font-AfacadFluxLight font-bold text-white mb-6">
                  1. Use of Website
                </h2>
                <ul className="space-y-4 text-gray-300">
                  <li className="flex items-start">
                    <span className="text-purple-400 mr-3 mt-1">•</span>
                    <span>You may use this site for lawful purposes only.</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-purple-400 mr-3 mt-1">•</span>
                    <span>Do not attempt unauthorized access or misuse any content.</span>
                  </li>
                </ul>
              </div>

              {/* Section 2: Content Ownership */}
              <div className="bg-slate-900/50 rounded-lg p-8 border border-gray-800/50">
                <h2 className="text-2xl font-AfacadFluxLight font-bold text-white mb-6">
                  2. Content Ownership
                </h2>
                <ul className="space-y-4 text-gray-300">
                  <li className="flex items-start">
                    <span className="text-purple-400 mr-3 mt-1">•</span>
                    <span>All text, images, and materials belong to Venturecorp.</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-purple-400 mr-3 mt-1">•</span>
                    <span>You may not copy, sell, or distribute our content without permission.</span>
                  </li>
                </ul>
              </div>

              {/* Section 3: Privacy */}
              <div className="bg-slate-900/50 rounded-lg p-8 border border-gray-800/50">
                <h2 className="text-2xl font-AfacadFluxLight font-bold text-white mb-6">
                  3. Privacy
                </h2>
                <ul className="space-y-4 text-gray-300">
                  <li className="flex items-start">
                    <span className="text-purple-400 mr-3 mt-1">•</span>
                    <span>We respect your privacy. Any personal data is handled according to our Privacy Policy.</span>
                  </li>
                </ul>
              </div>

              {/* Section 4: Third-Party Links */}
              <div className="bg-slate-900/50 rounded-lg p-8 border border-gray-800/50">
                <h2 className="text-2xl font-AfacadFluxLight font-bold text-white mb-6">
                  4. Third-Party Links
                </h2>
                <ul className="space-y-4 text-gray-300">
                  <li className="flex items-start">
                    <span className="text-purple-400 mr-3 mt-1">•</span>
                    <span>We may link to other websites. We are not responsible for their content.</span>
                  </li>
                </ul>
              </div>

              {/* Section 5: Updates to Terms */}
              <div className="bg-slate-900/50 rounded-lg p-8 border border-gray-800/50">
                <h2 className="text-2xl font-AfacadFluxLight font-bold text-white mb-6">
                  5. Updates to Terms
                </h2>
                <ul className="space-y-4 text-gray-300">
                  <li className="flex items-start">
                    <span className="text-purple-400 mr-3 mt-1">•</span>
                    <span>We may update these Terms at any time. Changes will be posted on this page.</span>
                  </li>
                </ul>
              </div>

              {/* Acceptance Statement */}
              <div className="bg-gradient-to-r from-purple-600/20 to-indigo-600/20 rounded-lg p-8 border border-purple-500/30">
                <p className="text-lg text-white font-medium text-center">
                  By continuing to use this site, you accept these Terms & Conditions.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default TermsAndConditions;
